module.exports = __webpack_public_path__ + "media/frontend/svg/artists2-4667d47e3ab6db9ed8e3d1bb64eed0de.svg";